var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitLab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 29.3294L21.7285 11.6991H10.2715L15.9999 29.3294H16.0001Z",
    fill: "#E24329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.3293L10.2715 11.699H2.24329L16 29.3293Z",
    fill: "#FC6D26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24328 11.699L0.502516 17.0568C0.425116 17.295 0.425105 17.5515 0.502485 17.7897C0.579865 18.0279 0.730664 18.2355 0.933269 18.3827L16 29.3294L2.24316 11.6991L2.24328 11.699Z",
    fill: "#FCA326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24329 11.699H10.2715L6.82141 1.08038C6.64386 0.533976 5.87088 0.534098 5.69345 1.08038L2.24329 11.699Z",
    fill: "#E24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 29.3293L21.7285 11.699H29.7568L15.9999 29.3293H16.0001Z",
    fill: "#FC6D26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7568 11.699L31.4976 17.0568C31.5749 17.295 31.5749 17.5516 31.4975 17.7897C31.4201 18.0279 31.2693 18.2355 31.0667 18.3827L16.0001 29.3294L29.7568 11.6991V11.699Z",
    fill: "#FCA326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7568 11.699H21.7285L25.1787 1.08038C25.3562 0.533976 26.1292 0.534098 26.3066 1.08038L29.7568 11.699Z",
    fill: "#E24329"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitLab);
export default __webpack_public_path__ + "static/media/GitLab.823d2980400c5f186d0699adee70934d.svg";
export { ForwardRef as ReactComponent };